import type { ComponentTheme } from '../types/component-theme';

export default {
    slots: {
        root: 'flex shrink-0 flex-col gap-0 overflow-hidden rounded-[1rem] border-[0.063rem] border-solid pb-3',
        header:
            'flex flex-wrap items-center gap-x-2 gap-y-1 border-b-[0.063rem] border-solid ' +
            'border-b-(--slate-alpha-14) px-4 pt-[0.7rem] pb-[0.6rem] font-(family-name:--primary-font) ' +
            'text-[0.62rem] font-extrabold uppercase tracking-[0.12em] text-(--accent-solid)'
    },
    variants: {
        top: {
            true: {
                root:
                    'border-(--glass-chip-border-hover) border-t-[0.188rem] border-t-(--accent-solid) ' +
                    'bg-(--glass-surface-bg-78) shadow-(--workflow-panel-shadow) ' +
                    '[backdrop-filter:blur(1rem)_saturate(180%)]',
                header: 'bg-(--glass-surface-bg-58)'
            },
            false: {
                root:
                    'border-(--glass-chip-border) bg-(--glass-chip-bg) shadow-(--details-card-shadow) ' +
                    '[backdrop-filter:blur(0.875rem)_saturate(160%)]',
                header: 'bg-transparent'
            }
        }
    }
} satisfies ComponentTheme;
